import React, { useEffect, useState } from "react";
import qrMyvnptAPK from "assets/imgs/QrCodeMyVNPT/qr-myvnpt-android.png";
import qrMyvnptIOS from "assets/imgs/QrCodeMyVNPT/qr-myvnpt-ios.png";
import appStore from "assets/imgs/QrCodeMyVNPT/app-store.svg";
import googlePlay from "assets/imgs/QrCodeMyVNPT/google-play.svg";
import bannerSucess from "assets/imgs/QrCodeMyVNPT/myvnpt-banner.png";
import banner from "assets/imgs/QrCodeMyVnptVer2/banner.png";
import successIcon from "assets/imgs/QrCodeMyVnptVer2/success.png";
import failIcon from "assets/imgs/QrCodeMyVnptVer2/fail.png";
import pendingIcon from "assets/imgs/QrCodeMyVnptVer2/pending.png";
import pendingSubIcon from "assets/imgs/QrCodeMyVnptVer2/pending-sub-icon.png";
import failSubIcon from "assets/imgs/QrCodeMyVnptVer2/fail-sub-icon.png";
import { QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST } from "global/environment";
import { BANNER_PACKAGE_CODE, DEVICE, formatPhoneNumber, TRANSACTION_TYPE } from "../constant/contanst";
import './style.scss';
import { QrCodeMyVNPTService } from "../services/QrCodeMyVNPTService";

const PaymentResult = ({ type, data }) => {
  const [banner, setBanner] = useState("");

  const icon = type === TRANSACTION_TYPE.SUCCESS ? successIcon : type === TRANSACTION_TYPE.FAIL ? failIcon : pendingIcon;
  const title = type === TRANSACTION_TYPE.SUCCESS ? "Thanh toán thành công" : type === TRANSACTION_TYPE.FAIL ? "Thanh toán thất bại" : "Giao dịch đang xử lý";
  const createDate = type === TRANSACTION_TYPE.SUCCESS ? data?.createDate : '';
  const iconSub = type === TRANSACTION_TYPE.FAIL ? failSubIcon : type === TRANSACTION_TYPE.PROCESS ? pendingSubIcon : null;
  const message = type === TRANSACTION_TYPE.FAIL ? data?.message : type === TRANSACTION_TYPE.PROCESS ? "Nếu đã thanh toán thành công, vui lòng đợi trong giây lát hoặc tải lại trang" : '';

  useEffect(() => {
    getListBannerByType({
      type: 1,
      channel: 3,
      pageType: BANNER_PACKAGE_CODE.ROAMING_RESULTTRANS
    })
  }, []);

  const getListBannerByType = async (payload) => {
    QrCodeMyVNPTService.getListBannerByType(payload, res => {
      if(res?.errorCode === '0' && res?.result[0]) {
        let banner = res?.rootImageUrl + res?.result
          ?.sort((a, b) => (a.position || 0) - (b.position || 0))
          ?.[0]?.imagePath;
        setBanner(banner);
      }
    }, err => {
      console.log(err);
    }); 
  };

  return (
    <div className="qr-code__payment-noti-v2">
      <div className="payment-noti-container">
        <div className="qr-code__payment-header">
          <img className="icon-payment-header" src={icon} alt="success" />
          <div className="qr-code__payment-title">{title}</div>
          {createDate && <div className="qr-code__payment-title-date">{createDate}</div>}
        </div>

        {
          (type === TRANSACTION_TYPE.FAIL || type === TRANSACTION_TYPE.PROCESS) && (
            <div className="qr-code__payment-note al-center">
              <div><img className="sub-icon" src={iconSub} alt="" /></div>
              <div>{message}</div>
            </div>
          )
        }
          
        <div className="divider-customm">
          {/* <div className="span span-left"></div> */}
          <div className="line-dashed"></div>
          {/* <div className="span span-right"></div> */}
        </div>
        
        {type === TRANSACTION_TYPE.SUCCESS &&(
          <div className="qr-code__payment-desc">
            <div className="qr-code__payment-subtitle">
              Dịch vụ: <span className="sub-string">{data?.serviceName}</span>
            </div>
            <div className="qr-code__payment-subtitle">
              Số thuê bao: 
              <span className="sub-string">
                {formatPhoneNumber(data?.phoneNumber)}
              </span>
            </div>
            <div className="qr-code__payment-subtitle">
              Mã giao dịch: <span className="sub-string">{data?.paymentTransId}</span>
            </div>
          </div>
        )}

        {type === TRANSACTION_TYPE.FAIL &&(
          <a className="qr-code__btn-custom-fail" href={QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST}>
            Chọn gói cước khác
          </a>
        )}

        {
          banner && 
          <a href="https://myvnpt.page.link/app-vnp">
            <div className="qr-code__payment-banner">
              <img src={banner} alt="banner" />
            </div>
          </a>
        }

        <div className="qr-code__payment-download-app">
          <div className="qr-code__payment-download-txt">
            Tải ứng dụng <a className="link-myvnpt" href="https://myvnpt.page.link/app-vnp">My VNPT</a> ngay để thanh toán cùng các ưu đãi hấp dẫn
          </div>
          <a href="https://myvnpt.page.link/dl" className="qr-code__payment-download-img-app">
            <img src={appStore} alt="appStore" />
            <img src={googlePlay} alt="googlePlay" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaymentResult);
